import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

export const useElementTrigger = (id: string, offsetTop = 0, log = false) => {
  const router = useRouter()
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    let mutationObserver: MutationObserver | null = null
    let cleanup: (() => void) | null = null

    const startTracking = (el: Element) => {
      const onScroll = () => {
        const { top } = el.getBoundingClientRect()

        setIsActive(Math.ceil(top) <= Math.ceil(offsetTop))
      }

      onScroll()

      window.addEventListener('scroll', onScroll)
      window.addEventListener('resize', onScroll)

      cleanup = () => {
        window.removeEventListener('scroll', onScroll)
        window.removeEventListener('resize', onScroll)
      }
    }

    const init = () => {
      const el = document.getElementById(id)

      if (el) {
        startTracking(el)
      } else {
        setIsActive(false)

        mutationObserver = new MutationObserver(() => {
          const newEl = document.getElementById(id)

          if (newEl) {
            mutationObserver?.disconnect()
            mutationObserver = null
            startTracking(newEl)
          }
        })

        mutationObserver.observe(document.body, {
          childList: true,
          subtree: true,
        })
      }
    }

    init()

    return () => {
      mutationObserver?.disconnect()
      cleanup?.()
    }
  }, [id, offsetTop, router.asPath])

  return isActive
}
